import { Components, Theme } from '@mui/material/styles';

import { BlackHeadings, BlackSmall, HoverBackground } from 'src/theme/colors';

const MuiMenuItem: Components<Theme>['MuiMenuItem'] = {
  styleOverrides: {
    root: {
      minHeight: 'unset',
      padding: '6px 16px',
      height: 'auto',
      color: BlackSmall,
      '&:hover': {
        color: BlackHeadings,
        background: HoverBackground,
      },
      '&.Mui-selected': {
        backgroundColor: 'rgba(0, 0, 0, 0.08)',
      },
      '&.Mui-disabled': {
        opacity: 0.5,
      },
      '&& .MuiListItemIcon-root': {
        minWidth: 0,
      },
      '& .MuiListItemText-root': {
        marginTop: 4,
        marginBottom: 4,
      },
    },
  },
};

export default MuiMenuItem;
